// extracted by mini-css-extract-plugin
module.exports = {"attention":"Attention_attention__A1HOV","info":"Attention_info__QnBYZ","success":"Attention_success__EmyX7","warning":"Attention_warning__E7rYj","error":"Attention_error__bEL5M"};